{ isActive, isProcessing, needsCC } = require 'app/common/lib/accounts'

module.exports = (paidAccount) ->
  needsCC(paidAccount?.standing) || (isActive(paidAccount) && !isProcessing(paidAccount?.standing))
